export default "__VITE_ASSET__CfCZnn6m__"